export const ORDER_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  DELIVERED: 'delivered',
  CANCELED: 'canceled',
}

export const PAYMENT_METHOD = {
  CREDIT_CARD: 'credit_card',
  DEBIT_CARD: 'debit_card',
  PAYPAL: 'paypal',
  BANK_TRANSFER: 'bank_transfer',
  CASH: 'cash',
}

export const CUSTOMER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  VIP: 'vip',
  BLOCKED: 'blocked',
}

export const TRANSACTION_STATUS = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  FAILED: 'failed',
  REFUNDED: 'refunded',
}

export const PRODUCT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  OUT_OF_STOCK: 'out_of_stock',
  DISCONTINUED: 'discontinued',
}

export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  STAFF: 'staff',
}

export const SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    href: '/',
    icon: 'LayoutDashboard',
  },
  {
    title: 'Orders',
    href: '/orders',
    icon: 'ShoppingBag',
  },
  {
    title: 'Customers',
    href: '/customers',
    icon: 'Users',
  },
  {
    title: 'Categories',
    href: '/categories',
    icon: 'Grid3x3',
  },
  {
    title: 'Transactions',
    href: '/transactions',
    icon: 'CreditCard',
  },
  {
    title: 'Products',
    href: '/products/add',
    icon: 'Package',
  },
  {
    title: 'Admin Role',
    href: '/admin/role',
    icon: 'Shield',
  },
]

export const STATUS_COLORS = {
  [ORDER_STATUS.PENDING]: 'warning',
  [ORDER_STATUS.COMPLETED]: 'success',
  [ORDER_STATUS.DELIVERED]: 'success',
  [ORDER_STATUS.CANCELED]: 'danger',
  
  [CUSTOMER_STATUS.ACTIVE]: 'success',
  [CUSTOMER_STATUS.INACTIVE]: 'secondary',
  [CUSTOMER_STATUS.VIP]: 'primary',
  [CUSTOMER_STATUS.BLOCKED]: 'danger',
  
  [TRANSACTION_STATUS.COMPLETED]: 'success',
  [TRANSACTION_STATUS.PENDING]: 'warning',
  [TRANSACTION_STATUS.FAILED]: 'danger',
  [TRANSACTION_STATUS.REFUNDED]: 'secondary',
  
  [PRODUCT_STATUS.ACTIVE]: 'success',
  [PRODUCT_STATUS.INACTIVE]: 'secondary',
  [PRODUCT_STATUS.OUT_OF_STOCK]: 'warning',
  [PRODUCT_STATUS.DISCONTINUED]: 'danger',
}

export const COUNTRIES = [
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'UK', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
]